import isEmpty from "lodash.isempty";

export default class Cookie {
    name = "delivery-data";
    days = 356;

    isSet() {
        const area = this.get()?.area;
        return area || !isEmpty(area);
    }

    update(data) {
        this.set(Object.assign(this.get(), data));
    }

    delete() {
        this.set({});
    }

    set(data) {
        data.version = 4;
        document.cookie =
            this.name +
            "=" +
            btoa(encodeURIComponent(JSON.stringify(data))) +
            "; path=/; samesite=strict; " +
            (location.protocol === "https:" ? "secure; " : "");
    }

    get() {
        let name = this.name + "=";
        let decodedCookie = document.cookie;
        let ca = decodedCookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                try {
                    let result = JSON.parse(
                        decodeURIComponent(
                            atob(c.substring(name.length, c.length))
                        )
                    );
                    if (!result.version) return {};
                    if (result.version < 3) return {};
                    return result;
                } catch (e) {
                    return {};
                }
            }
        }
        return {};
    }
}
